/**
 * How long a shop chat's AI reply may take (117C S4). Kept apart from
 * iklanChat.ts so the client's resources.ts can import it without pulling the
 * chat's prompts into the entry bundle. The Worker gives up on the AI before
 * the browser gives up on the Worker.
 */
export const CHAT_AI_CALL_MS = 40_000;
export const CHAT_CLIENT_WAIT_MS = 60_000;
